import PropTypes from "prop-types";
import { useTemporalyContent } from "../../../hooks";

const TemporaryContent = ({ startIn, stopIn, children }) => {
  const { show } = useTemporalyContent({ startIn, stopIn });

  return show && children;
};

TemporaryContent.defaultProps = {
  startIn: null,
};

TemporaryContent.propTypes = {
  startIn: PropTypes.string,
  stopIn: PropTypes.string.isRequired,
};

export default TemporaryContent;
